import ExhibitTypeList from "./ExhibitTypeList";

export default ExhibitTypeList